import * as yup from 'yup';

export const invoicePayloadSchema = yup.object().shape({
    type: yup.string().required(),
    invoice_id: yup.string().required(),
    invoice_number: yup.string().required(),
});

export type InvoicePayload = yup.InferType<typeof invoicePayloadSchema>;
